import styled from 'styled-components';

export const divStyle = { padding: '40px 30px' };
export const gridStyle = { fontSize: 15, paddingBottom: 0 };

export const ButtonWrapper = styled.div`
  width: fit-content;
`;

export const Subtitle = styled.div`
  font-size: 16px;
  font-weight: 300;
  margin-top: 8px;
`;
